/* ••[1]••••••••••••••••••••••••• EventCarouselController.ts •••••••••••••••••••••••••••••• */

/* ••[2]•••••••••• Components ••••••••••••••• */
import CCCEventCarousel from "../components/event-carousel/eventCarousel";

/* ••[2]•••••••••• Models ••••••••••••••• */
import EventModel from "./../models/EventModel";
import EventCarouselModel from "./../models/EventCarouselModel";

/* ••[2]•••••••••• Types ••••••••••••••• */
import { EventCarouselItem } from "../core/types/EventCarousel";

export default class EventCarouselController {
  private $anchor: HTMLElement | null = null;
  private CCCEventCarouselInstance: CCCEventCarousel | null;

  constructor(anchor: string) {
    try {
      this.$anchor = document.querySelector(anchor);

      if (!this.$anchor) {
        throw `Event Carousel - ${anchor} element not found in DOM`;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public get instance(): CCCEventCarousel | null {
    return this.CCCEventCarouselInstance;
  }

  public async init(): Promise<CCCEventCarousel | null> {
    if (this.$anchor) {
      if (await EventModel.isGlobalEventsCategoryPage()) {
        this.CCCEventCarouselInstance = new CCCEventCarousel();
        this.$anchor.appendChild(this.CCCEventCarouselInstance);
        await this.setData();
      }

      return this.CCCEventCarouselInstance;
    }
  }

  private async setData(): Promise<void> {
    if (this.CCCEventCarouselInstance) {
      try {
        const eventCarouselItems: Array<EventCarouselItem> =
          await EventCarouselModel.getEventCarouselData();

        this.CCCEventCarouselInstance.items = eventCarouselItems;
      } catch (error) {
        return null;
      }
    }
  }
}
